import { BusinessUnitAddressService } from '../model/business-unit-address.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { BusinessUnitAddress } from 'assets-model';
import { Observable } from 'rxjs';


export class BusinessUnitAddressDataSource extends CrudDataSource<BusinessUnitAddress> {

  constructor(private service: BusinessUnitAddressService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<BusinessUnitAddress>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


